import { client } from "../supabase";

/**
 * Wrapper de la RPC `saldar_capex_targets` (migración 20260909_capex_fase1_dual_write_rpc.sql).
 * Hace, ATÓMICO: el flip/materialización de cada target + la siembra de su evento en `pagos_capex`.
 * Si falla el evento (o cualquier paso) revierte todo (10.177/10.239). La caja la escribe el JS
 * DESPUÉS de esta RPC, así que un fallo acá deja también la caja sin escribir.
 *
 * @param {{ movimientoBancarioId:number, pais:string,
 *           items:Array<{tipo:'cuota'|'comp'|'activo'|'fob', id:number, monto_origen:number,
 *             moneda:string, monto_target:number, monto_local:number, tc:number|null, fecha:string,
 *             fecha_planificada?:string}>,
 *           usuarioId:number|null }} args
 */
export const saldarCapexTargets = async ({ movimientoBancarioId, pais, items, usuarioId }) => {
  const { data, error } = await client.rpc("saldar_capex_targets", {
    p_movimiento_bancario_id: movimientoBancarioId,
    p_pais: pais,
    p_items: items,
    p_usuario_id: usuarioId ?? null,
  });
  if (error) throw error;
  return data;
};

/**
 * Wrapper de la RPC `reversar_capex_targets` (migración 20260910_capex_fase2a_reversa.sql).
 * Hace, ATÓMICO (10.177/10.239): marca `reversado_at` los eventos de `pagos_capex` de ese movimiento
 * + revierte sus targets (sintéticos → DELETE; reales → 'pendiente' + limpia movimiento_bancario_id).
 * Espejo de la reversa que `handleDesvincularCaja` hacía en JS. El resto del unwind (borrar caja, reset
 * banco, revertir cuotas de crédito/factura) lo hace el JS DESPUÉS de esta RPC.
 *
 * @param {{ movimientoBancarioId:number, usuarioId:number|null }} args
 * @returns {Promise<object>} JSON con contadores (eventos_reversados, targets_tocados, …).
 */
export const reversarCapexTargets = async ({ movimientoBancarioId, usuarioId }) => {
  const { data, error } = await client.rpc("reversar_capex_targets", {
    p_movimiento_bancario_id: movimientoBancarioId,
    p_usuario_id: usuarioId ?? null,
  });
  if (error) throw error;
  return data;
};
